import { render, staticRenderFns } from "./PlatformsListHeaderWidget.vue?vue&type=template&id=7c86813c&scoped=true"
import script from "./PlatformsListHeaderWidget.vue?vue&type=script&lang=js"
export * from "./PlatformsListHeaderWidget.vue?vue&type=script&lang=js"
import style0 from "./PlatformsListHeaderWidget.vue?vue&type=style&index=0&id=7c86813c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c86813c",
  null
  
)

export default component.exports